export var ECheckPhoneActionTypes;

(function (ECheckPhoneActionTypes) {
  ECheckPhoneActionTypes["Loading"] = "phoneAuth/checkPhone/loading";
  ECheckPhoneActionTypes["Succeed"] = "phoneAuth/checkPhone/succeed";
  ECheckPhoneActionTypes["Failed"] = "phoneAuth/checkPhone/failed";
})(ECheckPhoneActionTypes || (ECheckPhoneActionTypes = {}));

export var EToggleAutosubmitActionTypes;

(function (EToggleAutosubmitActionTypes) {
  EToggleAutosubmitActionTypes["Toggle"] = "phoneAuth/toggleAutosubmit";
})(EToggleAutosubmitActionTypes || (EToggleAutosubmitActionTypes = {}));